import { apiClient } from '@/api/client';
import { type Psychologist, type PsychologistUpdateData } from '@/types/psychologist';

export const psychologistsApi = {
    get: async (id: string): Promise<Psychologist> => {
        const response = await apiClient.get<Psychologist>(`/psychologists/${id}`);
        return response.data;
    },

    update: async (id: string, data: Partial<PsychologistUpdateData>): Promise<Psychologist> => {
        const response = await apiClient.put<Psychologist>(`/psychologists/${id}`, data);
        return response.data;
    },
};
